"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dateStringMatchesFormatString = void 0;
const moment = require("moment");
/**
 * Checks a date matches a specified format.
 */
const dateStringMatchesFormatString = (dateString, formatString) => {
    return moment(dateString, formatString, true).isValid();
};
exports.dateStringMatchesFormatString = dateStringMatchesFormatString;
//# sourceMappingURL=dateStringMatchesFormatString.js.map